"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => `
    <rect x="8" y="10" width="88" height="36" rx="4" fill="black" fill-opacity="0.8"/>
    <rect x="28" y="21" width="10" height="17" rx="2" fill="#5EF2B8"/>
    <rect x="66" y="21" width="10" height="17" rx="2" fill="#5EF2B8"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M83 10H88L76 46H71L83 10Z" fill="white" fill-opacity="0.4"/>
`;
//# sourceMappingURL=frame-2.js.map